import LOGO from "../images/potros.png";

export const Team__Potros = {
  name: "Potros",
  logoImage: LOGO,
  teamImage: null,
  teamLogoColor: "#c37b00",
  teamJerseyColor: "#164F9D",

  // Stats
  gamesWon: 1,
  gamesLost: 2,
  gamesTied: 0,
  gamesTiedWon: 0,

  ownGoalsInFavor: 0,
  goalsScoredAgainst: 50 + 41 + 29,
  defaultGoals: 0,

  isChampion: false,
  isEliminated: false,

  players: [
    {
      goalsScored: 39 + 22 + 46,
    },
  ],
};
